import React from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
import { useLocation } from 'react-router-dom'

import ImgBox from '../../components/Gamification/ImgBox'
import CreatNft from '../../components/Gamification/CreatNft'
// import {Info} from '../../components/Gamification/InfoBox'
import { RowColumn } from '../../components/Row'

import { NFTTYPE } from '../../constants/bakery/nft'

const SoccerMain = styled.div`
  width: 890px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 100%;
  `};
`
const Main = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`
const activeClassName = 'ACTIVENAV'

export const Info = styled.div`
    color: ${({ theme }) => theme.bsText7};
    width: 432px;
    height: 202px;
    overflow-y: scroll;
    padding: 16px 30px;
    border-radius: 20px;
    background: ${({ theme }) => theme.bsBg2};
    ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 90%;
    height: auto;
    margin: 0 auto;
    margin-bottom: 20px;
    `};
`


export default function Soccer () {
  const location = useLocation()
  return (
    <SoccerMain>
      <Main>
        <ImgBox imgLink={'/images/nft/car.gif'}/>
        <RowColumn>
          <CreatNft type={NFTTYPE.CAR} />
          <Info className={location.pathname.indexOf('gamification/car') > -1 ? activeClassName : ''}>
            <Text fontSize={18} fontFamily={'Baloo Da'} fontWeight={700}>How does $CAR NFT work?</Text>
            <Text fontSize={14} marginTop={20}>1. One $CAR can be minted into one Blind-Box NFT, and then to be opened to win a random $CAR NFT.  There are 10 designs of the $CAR NFTs.</Text>
            <Text fontSize={14} marginTop={20}>2. $CAR NFT can be used to farm $BAKE. Users can lock $CAR into $CAR NFT to enhance the staking power of the $CAR NFT.</Text>
            <Text fontSize={14} marginTop={20}>3. These $CARs are not just only NFTs that can be collected, traded, and staked. Three of the $CAR NFTs will allow the lucky holder to own a real-world exclusive car (with Bakery & Binance cobranding wrapped)! The remaining $CAR NFTs can be converted to physical branded Tesla toy cars which can be delivered physically to any location in the world. This will happen when you choose to burn the $CAR NFT.</Text>
          </Info>
        </RowColumn>
      </Main>
    </SoccerMain>
  )
}